<template>
    <div class="RightPanel">
        <div class="RightPanel-top">
            <div class="commontitle">
                <div class="imgBox">
                    <img src="@/assets/images/msgt/titleIcon.png" />
                </div>
                <p>节能降碳</p>
            </div>
            <div class="content">
                <div class="content-left">
                    <svg id="svgRightPanel" data-v-5a4a5b9e="" width="100px" height="100px"
                        style="transform: scale(2, 2);position: relative;top:30%;" viewBox="0 0 100 100">
                        <defs data-v-5a4a5b9e="">
                            <polygon data-v-5a4a5b9e="" id="decoration-9-polygon-851ad76700814b3284130758903a1273"
                                points="15, 46.5, 21, 47.5, 21, 52.5, 15, 53.5"></polygon>
                        </defs>
                        <circle data-v-5a4a5b9e="" cx="50" cy="50" r="45" fill="transparent" stroke-width="10"
                            stroke-dasharray="80, 100, 30, 100" stroke="rgba(22,233,244, 0.5)">
                            <animateTransform data-v-5a4a5b9e="" attributeName="transform" type="rotate"
                                values="0 50 50;360 50 50" dur="3s" repeatCount="indefinite"></animateTransform>
                        </circle>
                        <circle data-v-5a4a5b9e="" cx="50" cy="50" r="45" fill="transparent" stroke-width="6"
                            stroke-dasharray="50, 66, 100, 66" stroke="rgba(22,233,244, 0.8)">
                            <animateTransform data-v-5a4a5b9e="" attributeName="transform" type="rotate"
                                values="0 50 50;-360 50 50" dur="3s" repeatCount="indefinite"></animateTransform>
                        </circle>
                        <circle data-v-5a4a5b9e="" cx="50" cy="50" r="38" fill="transparent" stroke="rgba(3,166,224,0.3)"
                            stroke-width="1" stroke-dasharray="5, 1"></circle>
                        <use data-v-5a4a5b9e="" xlink:href="#decoration-9-polygon-851ad76700814b3284130758903a1273"
                            fill="rgba(22,233,244, 0.8)" stroke="rgba(22,233,244, 0.5)">
                            <animateTransform data-v-5a4a5b9e="" attributeName="transform" type="rotate"
                                values="0 50 50;360 50 50" dur="3s" begin="0s" repeatCount="indefinite"></animateTransform>
                        </use>
                        <use data-v-5a4a5b9e="" xlink:href="#decoration-9-polygon-851ad76700814b3284130758903a1273"
                            stroke="rgba(22,233,244, 0.5)" fill="rgba(22,233,244, 0.8)">
                            <animateTransform data-v-5a4a5b9e="" attributeName="transform" type="rotate"
                                values="0 50 50;360 50 50" dur="3s" begin="0.15s" repeatCount="indefinite">
                            </animateTransform>
                        </use>
                        <use data-v-5a4a5b9e="" xlink:href="#decoration-9-polygon-851ad76700814b3284130758903a1273"
                            stroke="rgba(22,233,244, 0.5)" fill="transparent">
                            <animateTransform data-v-5a4a5b9e="" attributeName="transform" type="rotate"
                                values="0 50 50;360 50 50" dur="3s" begin="0.3s" repeatCount="indefinite">
                            </animateTransform>
                        </use>
                        <use data-v-5a4a5b9e="" xlink:href="#decoration-9-polygon-851ad76700814b3284130758903a1273"
                            fill="transparent" stroke="rgba(22,233,244, 0.5)">
                            <animateTransform data-v-5a4a5b9e="" attributeName="transform" type="rotate"
                                values="0 50 50;360 50 50" dur="3s" begin="0.45s" repeatCount="indefinite">
                            </animateTransform>
                        </use>
                        <use data-v-5a4a5b9e="" xlink:href="#decoration-9-polygon-851ad76700814b3284130758903a1273"
                            fill="transparent" stroke="rgba(22,233,244, 0.5)">
                            <animateTransform data-v-5a4a5b9e="" attributeName="transform" type="rotate"
                                values="0 50 50;360 50 50" dur="3s" begin="0.6s" repeatCount="indefinite">
                            </animateTransform>
                        </use>
                        <use data-v-5a4a5b9e="" xlink:href="#decoration-9-polygon-851ad76700814b3284130758903a1273"
                            stroke="rgba(22,233,244, 0.5)" fill="transparent">
                            <animateTransform data-v-5a4a5b9e="" attributeName="transform" type="rotate"
                                values="0 50 50;360 50 50" dur="3s" begin="0.75s" repeatCount="indefinite">
                            </animateTransform>
                        </use>
                        <use data-v-5a4a5b9e="" xlink:href="#decoration-9-polygon-851ad76700814b3284130758903a1273"
                            fill="transparent" stroke="rgba(22,233,244, 0.5)">
                            <animateTransform data-v-5a4a5b9e="" attributeName="transform" type="rotate"
                                values="0 50 50;360 50 50" dur="3s" begin="0.9s" repeatCount="indefinite">
                            </animateTransform>
                        </use>
                        <use data-v-5a4a5b9e="" xlink:href="#decoration-9-polygon-851ad76700814b3284130758903a1273"
                            fill="rgba(22,233,244, 0.8)" stroke="rgba(22,233,244, 0.5)">
                            <animateTransform data-v-5a4a5b9e="" attributeName="transform" type="rotate"
                                values="0 50 50;360 50 50" dur="3s" begin="1.05s" repeatCount="indefinite">
                            </animateTransform>
                        </use>
                        <use data-v-5a4a5b9e="" xlink:href="#decoration-9-polygon-851ad76700814b3284130758903a1273"
                            fill="transparent" stroke="rgba(22,233,244, 0.5)">
                            <animateTransform data-v-5a4a5b9e="" attributeName="transform" type="rotate"
                                values="0 50 50;360 50 50" dur="3s" begin="1.2s" repeatCount="indefinite">
                            </animateTransform>
                        </use>
                        <use data-v-5a4a5b9e="" xlink:href="#decoration-9-polygon-851ad76700814b3284130758903a1273"
                            stroke="rgba(22,233,244, 0.5)" fill="transparent">
                            <animateTransform data-v-5a4a5b9e="" attributeName="transform" type="rotate"
                                values="0 50 50;360 50 50" dur="3s" begin="1.35s" repeatCount="indefinite">
                            </animateTransform>
                        </use>
                        <use data-v-5a4a5b9e="" xlink:href="#decoration-9-polygon-851ad76700814b3284130758903a1273"
                            fill="transparent" stroke="rgba(22,233,244, 0.5)">
                            <animateTransform data-v-5a4a5b9e="" attributeName="transform" type="rotate"
                                values="0 50 50;360 50 50" dur="3s" begin="1.5s" repeatCount="indefinite">
                            </animateTransform>
                        </use>
                        <use data-v-5a4a5b9e="" xlink:href="#decoration-9-polygon-851ad76700814b3284130758903a1273"
                            stroke="rgba(22,233,244, 0.5)" fill="transparent">
                            <animateTransform data-v-5a4a5b9e="" attributeName="transform" type="rotate"
                                values="0 50 50;360 50 50" dur="3s" begin="1.65s" repeatCount="indefinite">
                            </animateTransform>
                        </use>
                        <use data-v-5a4a5b9e="" xlink:href="#decoration-9-polygon-851ad76700814b3284130758903a1273"
                            fill="transparent" stroke="rgba(22,233,244, 0.5)">
                            <animateTransform data-v-5a4a5b9e="" attributeName="transform" type="rotate"
                                values="0 50 50;360 50 50" dur="3s" begin="1.8s" repeatCount="indefinite">
                            </animateTransform>
                        </use>
                        <use data-v-5a4a5b9e="" xlink:href="#decoration-9-polygon-851ad76700814b3284130758903a1273"
                            fill="transparent" stroke="rgba(22,233,244, 0.5)">
                            <animateTransform data-v-5a4a5b9e="" attributeName="transform" type="rotate"
                                values="0 50 50;360 50 50" dur="3s" begin="1.95s" repeatCount="indefinite">
                            </animateTransform>
                        </use>
                        <use data-v-5a4a5b9e="" xlink:href="#decoration-9-polygon-851ad76700814b3284130758903a1273"
                            fill="transparent" stroke="rgba(22,233,244, 0.5)">
                            <animateTransform data-v-5a4a5b9e="" attributeName="transform" type="rotate"
                                values="0 50 50;360 50 50" dur="3s" begin="2.1s" repeatCount="indefinite">
                            </animateTransform>
                        </use>
                        <use data-v-5a4a5b9e="" xlink:href="#decoration-9-polygon-851ad76700814b3284130758903a1273"
                            stroke="rgba(22,233,244, 0.5)" fill="transparent">
                            <animateTransform data-v-5a4a5b9e="" attributeName="transform" type="rotate"
                                values="0 50 50;360 50 50" dur="3s" begin="2.25s" repeatCount="indefinite">
                            </animateTransform>
                        </use>
                        <use data-v-5a4a5b9e="" xlink:href="#decoration-9-polygon-851ad76700814b3284130758903a1273"
                            fill="rgba(22,233,244, 0.8)" stroke="rgba(22,233,244, 0.5)">
                            <animateTransform data-v-5a4a5b9e="" attributeName="transform" type="rotate"
                                values="0 50 50;360 50 50" dur="3s" begin="2.4s" repeatCount="indefinite">
                            </animateTransform>
                        </use>
                        <use data-v-5a4a5b9e="" xlink:href="#decoration-9-polygon-851ad76700814b3284130758903a1273"
                            fill="transparent" stroke="rgba(22,233,244, 0.5)">
                            <animateTransform data-v-5a4a5b9e="" attributeName="transform" type="rotate"
                                values="0 50 50;360 50 50" dur="3s" begin="2.55s" repeatCount="indefinite">
                            </animateTransform>
                        </use>
                        <use data-v-5a4a5b9e="" xlink:href="#decoration-9-polygon-851ad76700814b3284130758903a1273"
                            stroke="rgba(22,233,244, 0.5)" fill="transparent">
                            <animateTransform data-v-5a4a5b9e="" attributeName="transform" type="rotate"
                                values="0 50 50;360 50 50" dur="3s" begin="2.7s" repeatCount="indefinite">
                            </animateTransform>
                        </use>
                        <use data-v-5a4a5b9e="" xlink:href="#decoration-9-polygon-851ad76700814b3284130758903a1273"
                            fill="rgba(22,233,244, 0.8)" stroke="rgba(22,233,244, 0.5)">
                            <animateTransform data-v-5a4a5b9e="" attributeName="transform" type="rotate"
                                values="0 50 50;360 50 50" dur="3s" begin="2.85s" repeatCount="indefinite">
                            </animateTransform>
                        </use>
                        <circle data-v-5a4a5b9e="" cx="50" cy="50" r="26" fill="transparent" stroke="rgba(3,166,224,0.3)"
                            stroke-width="1" stroke-dasharray="5, 1"></circle>
                    </svg>
                    <div class="value">31%</div>
                    <div class="name">年度综合节能率</div>
                </div>
                <div class="content-right">
                    <div v-for="(v, i) in topRightList" :key="i">
                        <div class="value">{{ v.value }}</div>
                        <div class="name">{{ v.name }}</div>
                        <div v-if="v?.rateList?.length" class="rate">
                            <div class="rateContent" v-for="(item, index) in v.rateList" :key="index">
                                <div class="rateName">{{ item.name }}</div>
                                <el-image style="margin:0 2px" fit="fill"
                                    :src="item.arrow === 'up' ? upArrow : downArrow"></el-image>
                                <div :class="item.arrow === 'up' ? 'rateValueUp' : 'rateValueDown'">{{ item.value }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="RightPanel-center">
            <div class="commontitle">
                <div class="imgBox">
                    <img src="@/assets/images/msgt/titleIcon.png" />
                </div>
                <p>指标</p>
            </div>
            <div class="content">
                <CenterContent :listData="centerList" />
            </div>
        </div>
        <div class="RightPanel-bottom">
            <div class="commontitle">
                <div class="imgBox">
                    <img src="@/assets/images/msgt/titleIcon.png" />
                </div>
                <p>典型单位</p>
            </div>
            <div class="content">
                <BottomContent :listData="bottomList" />
            </div>
        </div>
    </div>
</template>

<script>
import CenterContent from "./CenterContent";
import BottomContent from "./BottomContent";
export default {
    name: "RightPanel",
    props: {},
    components: { CenterContent, BottomContent },
    data() {
        return {
            upArrow: require('@/assets/images/msgt/upArrow.png'),
            downArrow: require('@/assets/images/msgt/downArrow.png'),
            topRightList: [{
                value: '1.8t',
                name: '今日碳排放',
                // rateList: [{
                //     name: '日环比',
                //     value: '11%',
                //     arrow: 'down'
                // }],
            }, {
                value: '33.1t',
                name: '本月碳排放',
                // rateList: [{
                //     name: '月环比',
                //     value: '11%',
                //     arrow: 'down'
                // }],
            }, {
                value: '561t',
                name: '总和碳排放',
            }, {
                value: '252t',
                name: '累积减碳',
            }],
            centerList: [{
                name: '万元GDP指标',
                value1: '120,000',
            }, {
                name: '单位建筑面积能耗指标',
                value1: '国家指标7',
                value2: '单位指标6',
            }, {
                name: '单位建筑面积电耗指标',
                value1: '国家指标44',
                value2: '单位指标39',
            }, {
                name: '人均综合能耗指标',
                value1: '国家指标299',
                value2: '单位指标269',
            }, {
                name: '人均综合电耗指标',
                value1: '国家指标1943',
                value2: '单位指标1748',
            }, {
                name: '人均用水量指标',
                value1: '国家指标402',
                value2: '单位指标363',
            }],
            bottomList: ['东坡区政府', '仁寿县第一中学', '眉山市工程职业技术学院', '四川鸿鑫国泰电缆有限责任公司',
                '眉山市中医院', '眉山市财务中心', '眉山风景区', '眉山市电信大厦']
        }
    },
    computed: {},
    methods: {
        svgResize() {
            if (window.innerWidth >= 2560) {
                document.getElementById('svgRightPanel').style.transform = 'scale(3, 3)'
            } else {
                document.getElementById('svgRightPanel').style.transform = 'scale(2, 2)'
            }
        }
    },
    created() {

    },
    mounted() {
        this.svgResize();
        window.addEventListener("resize", this.svgResize);
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.svgResize);
    }
}
</script> 

<style lang="scss" scoped>
.RightPanel {
    width: 100%;
    height: 100%;

    .commontitle {
        width: 100%;
        height: 36px;
        background: url("~@/assets/images/msgt/smartLeftTitleBg.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        @include setFlexStart;

        .imgBox {
            margin: 0 6px 0 30px;
        }

        p {
            color: #dfe6ee;
            font-weight: bold;
            font-size: 16px;
        }
    }

    &-top {
        // height: 33%;
        height: 240px;

        .content {
            width: calc(100% - 32px);
            height: 204px;
            background: url("~@/assets/images/msgt/userContent.png");
            background-repeat: no-repeat;
            background-size: 100% 100%;
            @include setFlexAround;
            font-family: PingFangSC-Regular, PingFang SC;
            color: #A1A7B8;
            padding-left: 16px;
            padding-right: 16px;

            // padding-top: 3px;
            // position: relative;
            // top: -3px;

            &-left {
                width: 170px;
                height: 170px;
                @include setFlexCenter;
                color: #FFFFFF;
                flex-direction: column;

                .value {
                    // background: url("~@/assets/images/msgt/rateCircle.gif");
                    // background-repeat: no-repeat;
                    // background-size: 100% 100%;
                    @include setFlexCenter;
                    width: 120px;
                    height: 120px;
                    font-size: 26px;
                    font-family: DINAlternate-Bold, DINAlternate;
                    font-weight: bold;
                    line-height: 26px;

                    position: relative;
                    top: -10%;
                }

                .name {
                    margin-top: 5px;
                    width: 160px;
                    height: 18px;
                    font-size: 18px;
                    font-family: SourceHanSansSC-Medium, SourceHanSansSC;
                    font-weight: 500;
                    line-height: 18px;
                    text-align: center;
                }
            }

            &-right {
                width: 180px;
                height: 180px;
                @include setFlexBetween;
                flex-wrap: wrap;

                &>div {
                    width: 80px;
                    height: 80px;
                    background: url("~@/assets/images/msgt/circle.png");
                    background-repeat: no-repeat;
                    background-size: 100% 100%;
                    @include setFlexCenter;
                    flex-direction: column;

                    .name {
                        margin-top: 4px;
                        height: 12px;
                        font-size: 12px;
                        font-family: MicrosoftYaHei;
                        color: #16E9F4;
                        line-height: 12px;
                    }

                    .value {
                        height: 18px;
                        font-size: 18px;
                        font-family: DINAlternate-Bold, DINAlternate;
                        font-weight: bold;
                        color: #FFFFFF;
                        line-height: 18px;
                    }

                    .rate {
                        margin-top: 4px;
                        @include setFlexBetween;
                        font-size: 12px;
                        height: 12px;
                        line-height: 12px;

                        .rateContent {
                            @include setFlexBetween;

                            .rateName {
                                color: #C9CCD6;
                            }

                            .rateValueDown {
                                width: 25px;
                                color: #E54553;
                            }

                            .rateValueUp {
                                width: 25px;
                                color: #16E9F4;
                            }
                        }
                    }

                }
            }
        }
    }

    &-center {
        margin-top: 16px;
        height: calc(50% - 136px);
        // height: 30%;
        // height: 230px;

        .content {
            width: calc(100% - 32px);
            padding: 0 16px;
            height: calc(100% - 36px);
            // height: 194px;

        }
    }

    &-bottom {
        margin-top: 16px;
        height: calc(50% - 136px);
        // height: 31%;
        // height: 231px;

        .content {
            width: calc(100% - 32px);
            height: calc(100% - 36px);
            // height: 195px;
            background: url("~@/assets/images/msgt/smartRightBottomContentBg.png");
            background-repeat: no-repeat;
            background-size: 100% 100%;
            @include setFlexAround;
            font-family: PingFangSC-Regular, PingFang SC;
            color: #A1A7B8;
            padding: 0 16px;
        }
    }
}
</style>